<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="门店管理" name="first">
        <div>
          <div class="title_div">
            <span class="title-span">门店名称:</span>
            <el-select
            filterable
              clearable
              v-model="mdParams.name"
              size="small"
              class="title-select"
              @change="mdStortChange"
            >
              <el-option
                v-for="item in this.mdSelectList"
                :value="item.name"
                :key="item.id"
                >{{ item.name }}</el-option
              >
            </el-select>
            <span class="title-span">创建日期:</span>
            <el-date-picker
              @change="mdStartChange"
              v-model="mdParams.createDateStart"
              size="small"
              class="title-date1"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
            至
            <el-date-picker
              @change="mdEndChange"
              v-model="mdParams.createDateEnd"
              size="small"
              class="title-date2"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              class="creat-button"
              type="primary"
              size="small"
              @click="creatmdDialogVisible = true"
              >新建门店
            </el-button>
          </div>
          <div class="mm-tb">
            <el-table :data="mdList" style="width: 100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="name" label="门店名称" align="center">
              </el-table-column>
              <el-table-column
                prop="personInCharge"
                label="负责人"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="empTotal" label="员工数量" align="center">
              </el-table-column>
              <el-table-column label="创建日期" align="center">
                <template slot-scope="scope">{{
                  scope.row.createDate.substring(0, 10)
                }}</template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="medium"
                    @click="mdEdit(scope.row)"
                    >编辑</el-button
                  >
                  <!-- <el-button type="text" size="medium" @click="deletMd(scope.row.id)">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              class="mm-page"
              @size-change="mdSizeChange"
              @current-change="mdCurrentChange"
              :current-page.sync="mdResult.current"
              :page-size="mdResult.size"
              layout="total,prev, pager, next, sizes"
              :total="mdResult.total"
              :page-sizes="[10, 20, 30, 40, 50]"
            >
            </el-pagination>
          </div>
          <el-dialog
            title="新建门店"
            :visible.sync="creatmdDialogVisible"
            width="30%"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">门 店 名 称:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdCreatParams.name"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">门 店 地 址:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdCreatParams.address"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">门店负责人:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdCreatParams.personInCharge"
              ></el-input>
            </div>
            <div class="dialog-div" style="height: 160px">
              <span class="title-span" style="float: left">门 店 照 片:</span>
              <el-upload
                style="float: left"
                class="avatar-uploader"
                accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                :headers="headers"
                :action="upLoadUrl"
                :show-file-list="false"
                :on-success="creatHandleAvatarSuccess"
                :before-upload="creatBeforeAvatarUpload"
              >
                <img v-if="creatImageUrl" :src="creatImageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="creatmdDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="createmdCommit"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <el-dialog
            title="编辑门店"
            :visible.sync="editmdDialogVisible"
            width="30%"
            :close-on-click-modal="false"
          >
            <div class="dialog-div">
              <span class="title-span">门 店 名 称:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdEditParams.name"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">门 店 地 址:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdEditParams.address"
              ></el-input>
            </div>
            <div class="dialog-div">
              <span class="title-span">门店负责人:</span>
              <el-input
                size="small"
                class="title-select"
                v-model="mdEditParams.personInCharge"
              ></el-input>
            </div>
            <div class="dialog-div" style="height: 160px">
              <span class="title-span" style="float: left">门 店 照 片:</span>
              <el-upload
                style="float: left"
                class="avatar-uploader"
                accept=".png,.jpg,.jpeg,.JPG,.JPEG"
                :headers="headers"
                :action="upLoadUrl"
                :show-file-list="false"
                :on-success="editHandleAvatarSuccess"
                :before-upload="editBeforeAvatarUpload"
              >
                <img v-if="editImageUrl" :src="editImageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="editmdDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="editCommit">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
      <el-tab-pane label="账号管理" name="second"> </el-tab-pane>
      <!--      <el-tab-pane label="角色权限" name="three">-->
      <!--        <div>-->

      <!--        </div>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="会员等级" name="four">
        <div></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getDeptList,
  getAntDeptSelect,
  addDept,
  getDeptById,
  updateDept,
  deleteDeptById,
  getCountList,
  getRolesSelect,
  addUser,
  getUserById,
  updateUser,
  initPassword,
  deleteUser,
} from "../../api/BusinessManagement.js";
import { globelurl, posturl } from "../../api/axios.js";

export default {
  name: "BusinessManagement",
  data() {
    return {
      activeName: "first",
      upLoadUrl: posturl,
      headers: { "X-Access-Token": sessionStorage.token },
      mdParams: {
        createDateStart: "",
        createDateEnd: "",
        name: "",
        pageNo: 1,
        pageSize: 10,
      },
      mdCreatParams: {
        name: "",
        personInCharge: "",
        address: "",
        filePath: "",
      },
      mdEditParams: {
        id: "",
        name: "",
        personInCharge: "",
        address: "",
        filePath: "",
      },
      creatmdDialogVisible: false,
      editmdDialogVisible: false,
      mdTableData: [],
      mdCurrentPage: 0,
      mdResult: {},
      mdList: [],
      mdSelectList: [],
      zhParams: {
        createDateStart: "",
        createDateEnd: "",
        userName: "",
        realName: "",
        name: "",
        deptName: "",
        pageNo: 1,
        pageSize: 10,
      },
      zhCreatParams: {
        userName: "",
        realName: "",
        password: "111111",
        phone: "",
        shopId: "",
        roleId: "",
      },
      zhEditParams: {
        userName: "",
        realname: "",
        userId: "",
        phone: "",
        shopId: "",
        roleId: "",
      },
      zhResult: {},
      zhList: [],
      zhCurrentPage: 0,
      creatImageUrl: "",
      editImageUrl: "",
      creatzhDialogVisible: false,
      editzhDialogVisible: false,
      changezhDialogVisible: false,
      jsSelectList: [],
      changePwdstr: "",
      changePwdstr1: "",
      changeuid: "",
    };
  },
  mounted() {
    this.getDeptList(this.mdParams);
    this.getAntDeptSelect();
    this.getRolesSelect();
  },
  methods: {
    //tab栏切换
    handleClick(tab, event) {
      if (tab.label == "门店管理") {
      } else if (tab.label == "账号管理") {
        this.$router.push("/BusinessManagement/NumberManagement");
      }
      // else if (tab.label == '角色权限') {
      //   this.$router.push('/BusinessManagement/RolePermissions');
      // }
      else if (tab.label == "会员等级") {
        this.$router.push("/BusinessManagement/MembershipLevel");
      }
    },
    //门店管理分页 每页几条
    mdSizeChange(newSize) {
      this.mdParams.pageSize = newSize;
      this.getDeptList(this.mdParams);
    },
    //门店管理页码跳转
    mdCurrentChange(newPage) {
      this.mdParams.pageNo = newPage;
      this.getDeptList(this.mdParams);
    },
    //获取门店列表
    getDeptList(params) {
      getDeptList(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          }
          this.mdResult = res.data.result;
          this.mdList = res.data.result.records;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        }
      });
    },
    //门店下拉菜单改变
    mdStortChange(val) {
      this.mdParams.pageNo = 1;
      this.getDeptList(this.mdParams);
    },
    //门店开始时间改变
    mdStartChange(val) {
      if (
        this.mdParams.createDateStart &&
        this.mdParams.createDateEnd &&
        new Date(this.mdParams.createDateStart).getTime() >
          new Date(this.mdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.mdParams.pageNo = 1;
      this.getDeptList(this.mdParams);
    },
    //门店结束时间改变
    mdEndChange(val) {
      if (
        this.mdParams.createDateStart &&
        this.mdParams.createDateEnd &&
        new Date(this.mdParams.createDateStart).getTime() >
          new Date(this.mdParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.mdParams.pageNo = 1;
      this.getDeptList(this.mdParams);
    },
    //新建门店图片上传
    creatHandleAvatarSuccess(res, file) {
      this.mdCreatParams.filePath = res.result.pathList[0];
      this.creatImageUrl = globelurl + res.result.pathList[0];
    },
    creatBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //编辑门店图片上传
    editHandleAvatarSuccess(res, file) {
      this.mdEditParams.filePath = res.result.pathList[0];
      this.editImageUrl = globelurl + res.result.pathList[0];
    },
    editBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    //新建门店提交
    createmdCommit() {
      if (this.mdCreatParams.name == "") {
        this.$message.error("请输入门店名称");
      } else if (this.mdCreatParams.address == "") {
        this.$message.error("请输入门店地址");
      } else if (this.mdCreatParams.personInCharge == "") {
        this.$message.error("请输入门店负责人");
      } else if (this.mdCreatParams.filePath == globelurl) {
        this.$message.error("请上传门店照片");
      } else {
        addDept(this.mdCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建门店成功");
              this.creatmdDialogVisible = false;
              this.getDeptList(this.mdParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //获取门店信息
    mdEdit(val) {
      this.editImageUrl = "";
      getDeptById({ id: val.id }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.editmdDialogVisible = true;
            this.mdEditParams.id = res.data.result.id;
            this.mdEditParams.name = res.data.result.name;
            this.mdEditParams.address = res.data.result.address;
            this.mdEditParams.personInCharge = res.data.result.personInCharge;
            this.mdEditParams.filePath = res.data.result.filePath;
            this.editImageUrl = globelurl + res.data.result.filePath;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑门店信息提交
    editCommit() {
      if (this.mdEditParams.name == "") {
        this.$message.error("请输入门店名称");
      } else if (this.mdEditParams.address == "") {
        this.$message.error("请输入门店地址");
      } else if (this.mdEditParams.personInCharge == "") {
        this.$message.error("请输入门店负责人");
      } else if (this.mdEditParams.filePath == globelurl) {
        this.$message.error("请上传门店照片");
      } else {
        updateDept(this.mdEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("编辑门店成功");
              this.editmdDialogVisible = false;
              this.getDeptList(this.mdParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //删除门店
    deletMd(id) {
      this.$confirm("此操作将永久删除该门店, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteDeptById({ id: id }).then((res) => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: "查无数据",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getDeptList(this.mdParams);
              }
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //获取账号列表
    getCountList(params) {
      getCountList(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.zhResult = res.data.result;
            this.zhList = res.data.result.records;
            console.log(this.zhList);
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //账号管理页码跳转
    zhSizeChange(newSize) {
      this.zhParams.pagesize = newSize;
      this.getCountList(this.zhParams);
    },
    //账号管理页码跳转
    zhCurrentChange(newPage) {
      this.zhParams.pageNo = newPage;
      this.getCountList(this.zhParams);
    },
    //账号管理门店下拉菜单改变
    zhStortChange(val) {
      this.getCountList(this.zhParams);
    },
    //账号开始时间改变
    zhStartChange(val) {
      this.getCountList(this.zhParams);
    },
    //账号结束时间改变
    zhEndChange(val) {
      this.getCountList(this.zhParams);
    },
    //账号检索输入框改变
    userNameChange() {
      this.getCountList(this.zhParams);
    },
    //姓名检索输入框改变
    realNameChange() {
      this.getCountList(this.zhParams);
    },
    //获取角色下拉菜单
    getRolesSelect() {
      getRolesSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.jsSelectList = res.data.result;
          }
        }
      });
    },
    //新建账号提交
    createzhCommit() {
      // console.log(this.zhCreatParams)
      var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!phonereg.test(this.zhCreatParams.phone)) {
        this.$message.error("请输入正确联系电话");
      } else if (this.zhCreatParams.userName == "") {
        this.$message.error("请输入账号");
      } else if (this.zhCreatParams.realName == "") {
        this.$message.error("请输入姓名");
      } else if (this.zhCreatParams.password == "") {
        this.$message.error("请输入密码");
      } else if (this.zhCreatParams.phone == "") {
        this.$message.error("请输入联系电话");
      } else if (this.zhCreatParams.shopId == "") {
        this.$message.error("请选择部门");
      } else if (this.zhCreatParams.roleId == "") {
        this.$message.error("请选择角色");
      } else {
        addUser(this.zhCreatParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建账号成功");
              this.creatzhDialogVisible = false;
              this.getCountList(this.zhParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //获取账号信息
    zhEdit(val) {
      console.log(val);
      getUserById({ userId: val.userId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.editzhDialogVisible = true;
            this.zhEditParams.userName = res.data.result.userName;
            this.zhEditParams.userId = res.data.result.userId;
            this.zhEditParams.realname = res.data.result.realname;
            this.zhEditParams.phone = res.data.result.phone;
            this.zhEditParams.shopId = res.data.result.shopId;
            this.zhEditParams.roleId = res.data.result.roleId;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //编辑账号提交
    editzhCommit() {
      // console.log(this.zhCreatParams)
      var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!phonereg.test(this.zhEditParams.phone)) {
        this.$message.error("请输入正确联系电话");
      } else if (this.zhEditParams.userName == "") {
        this.$message.error("请输入账号");
      } else if (this.zhEditParams.realName == "") {
        this.$message.error("请输入姓名");
      } else if (this.zhEditParams.phone == "") {
        this.$message.error("请输入联系电话");
      } else if (this.zhEditParams.shopId == "") {
        this.$message.error("请选择部门");
      } else if (this.zhEditParams.roleId == "") {
        this.$message.error("请选择角色");
      } else {
        updateUser(this.zhEditParams).then((res) => {
          if (res.status === 200 && res.data.success) {
            if (res.data.result.total === 0) {
              this.$Notice.open({
                title: "查无数据",
              });
            } else {
              this.$message.success("新建账号成功");
              this.editzhDialogVisible = false;
              this.getCountList(this.zhParams);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //修改密码
    changePwd(val) {
      this.changezhDialogVisible = true;
      this.changeuid = val;
    },
    changezhCommit() {
      console.log(this.changePwdstr === this.changePwdstr1);
      console.log(this.changeuid);
      if (this.changePwdstr == "") {
        this.$message.error("请输入新密码");
      } else if (this.changePwdstr1 == "") {
        this.$message.error("请输入确认新密码");
      } else if (this.changePwdstr.length < 6) {
        this.$message.error("密码最少为六位");
      } else if (this.changePwdstr1.length < 6) {
        this.$message.error("密码最少为六位");
      } else if (this.changePwdstr !== this.changePwdstr1) {
        this.$message.error("新密码与确认新密码不一致");
      } else {
        initPassword({
          userId: this.changeuid,
          password: this.changePwdstr,
        }).then((res) => {
          console.log(res.status);
          console.log(res.data.success);
          if (res.status === 200 && res.data.success) {
            this.$message.success(res.data.message);
            this.changezhDialogVisible = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //删除账号
    deletZh(id) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteUser({ userId: id }).then((res) => {
            if (res.status === 200 && res.data.success) {
              if (res.data.result.total === 0) {
                this.$Notice.open({
                  title: "查无数据",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getCountList(this.zhParams);
              }
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.title-span {
  font-size: 16px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  margin-left: 20px;
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}

.dialog-div {
  margin: 20px 0;
}

.orderMain {
  padding: 30px;
}
</style>

<style>
.el-upload {
  border: 1px dashed #d9d9d9;
  margin-left: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
